/**
 * ثوابت مشتركة لتصميم حقول النماذج — توحيد الشكل بين صفحات التسجيل وغيرها.
 */
export const inputBaseCls =
  "block w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 " +
  "focus:border-sa-500 focus:outline-none focus:ring-2 focus:ring-sa-500/40 disabled:opacity-60";

export const inputReadOnlyCls =
  inputBaseCls + " bg-neutral-50 cursor-not-allowed border-neutral-200";

export const labelCls = "mb-1 block text-sm font-medium text-sa-800";
export const helpCls = "mt-1 text-xs text-gray-500";
